import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { ControlPanel } from '../ControlPanel';
import { store, persistor } from '../../app/store';

type ControlPanelPropsParam = {
  appName: string;
};

export const App = ({ appName }: ControlPanelPropsParam) => {
  return (
    <Provider store={store}>
      {/* @ts-ignore */}
      <PersistGate loading={null} persistor={persistor}>
        <ControlPanel appName={appName} />
      </PersistGate>
    </Provider>
  );
};
